module.exports = __webpack_public_path__ + "img/minslide-product.cef94332.jpg";